// extracted by mini-css-extract-plugin
export default {"tools":"RecycleBin_tools__Txc5b","a":"RecycleBin_a__jgEIv","toolRow":"RecycleBin_toolRow__8j8PC"};